module.exports = "mat-form-field {\n  width: 100%;\n}\n"